import fetchTemplates from './fetchTemplates';
import fetchTemplate from './fetchTemplate';
import createTemplate from './createTemplate';
import updateTemplate from './updateTemplate';
import deleteTemplate from './deleteTemplate';

export default {
    fetchTemplates,
    fetchTemplate,
    createTemplate,
    updateTemplate,
    deleteTemplate,
};